import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import type { PayloadAction } from '@reduxjs/toolkit';

interface InitialSegments {
  origin?: any;
  destination?: any;
}

interface SetSegments {
  index: number;
  stop?: any;
  overwrite?: any;
}

export interface PlannerSegmentsInformation {
  plannerSegmentsInformation: Array<any>
}

const initialState : PlannerSegmentsInformation = {
  plannerSegmentsInformation: [null, null],
};

export const plannerSegmentsSlice = createSlice({
  name: 'plannerSegmentsSlice',
  initialState,
  reducers: {
    init: (state, action: PayloadAction<InitialSegments>) => {
      if (action.payload !== undefined) {
        state.plannerSegmentsInformation = [];
        state.plannerSegmentsInformation.push(action.payload.origin);
        state.plannerSegmentsInformation.push(action.payload.destination,);
      }
    },
    swap: (state) => {
      let origin = state.plannerSegmentsInformation[0];
      let indexDest = state.plannerSegmentsInformation.length - 1;
      state.plannerSegmentsInformation[0] = state.plannerSegmentsInformation[indexDest];
      state.plannerSegmentsInformation[indexDest] = origin;
    },
    delete: (state, action) => {
      state.plannerSegmentsInformation[action.payload]=null;
    },
    set: (state, action: PayloadAction<SetSegments>) => {
      if(Number(action.payload?.index) === 0) state.plannerSegmentsInformation[0] = action.payload.stop;
      if(Number(action.payload?.index) === 1) state.plannerSegmentsInformation[1] = action.payload.stop;
      // if(action.payload?.index===null) {
      //   state.plannerSegmentsInformation[state.plannerSegmentsInformation.indexOf(null)] = action.payload.stop;
      // } else if(action.payload.index<state.plannerSegmentsInformation.length) {
      //   if (state.plannerSegmentsInformation[action.payload?.index] === null || action.payload.overwrite) {
      //     state.plannerSegmentsInformation[action.payload?.index] = action.payload.stop;
      //   } else {
      //     for (let i = 0; i < state.plannerSegmentsInformation.length; i++) {
      //       if (state.plannerSegmentsInformation[i] === null) {
      //         state.plannerSegmentsInformation[i] = action.payload.stop;
      //         break;
      //       }
      //     }
      //   }
      // }
    },
    resetSegments: (state) => {
      state.plannerSegmentsInformation = initialState.plannerSegmentsInformation;
    },
  },
});


export const { set, resetSegments, swap } = plannerSegmentsSlice.actions;

export const plannerSegmentsInformation = (state: RootState) => state.plannerSegmentsSlice.plannerSegmentsInformation;
